import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ChangePassword() {
  const nav = useNavigate();
  const { refresh, user } = useAuth();
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== confirm) { toast.error("Passwords do not match"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { new_password: pw });
      const u = await refresh();
      toast.success("Password changed");
      if (u.role === "admin") nav("/admin");
      else if (!u.profile_complete) nav("/complete-profile");
      else nav("/seller");
    } catch (e) { toast.error(apiError(e)); }
    setBusy(false);
  };

  return (
    <div className="min-h-screen grid place-items-center bg-secondary/40 p-6">
      <div className="w-full max-w-sm bg-card border rounded-2xl p-8 shadow-lg">
        <div className="h-12 w-12 rounded-xl bg-primary/10 grid place-items-center mb-4"><KeyRound className="h-6 w-6 text-primary" /></div>
        <h1 className="font-heading text-2xl font-extrabold">Change Your Password</h1>
        <p className="text-muted-foreground text-sm font-medium mb-6">
          {user?.must_change_password
            ? "You must change your temporary password before accessing your dashboard."
            : "Set a new password."}
        </p>
        <form onSubmit={submit} className="space-y-4">
          <div><Label>New Password</Label><Input data-testid="new-password" type="password" value={pw} onChange={(e) => setPw(e.target.value)} required /></div>
          <div><Label>Confirm Password</Label><Input data-testid="confirm-password" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required /></div>
          <Button data-testid="change-password-submit" type="submit" disabled={busy} className="w-full font-bold h-11">
            {busy ? "Saving…" : "Change Password & Continue"}
          </Button>
        </form>
      </div>
    </div>
  );
}
